<template>
<v-layout>
  <v-select v-if="isSwitch" box dense :single-line="hideDetails" :label="label" :hide-details="hideDetails" v-model="selectedValue" :items="itemsSwitch" append-icon=""></v-select>
  <v-select v-else-if="isLevel" box dense :single-line="hideDetails" :label="label" :hide-details="hideDetails" v-model="selectedValue" :items="itemsLevel" append-icon=""></v-select>
  <v-select v-else-if="isDoorLock" box dense :single-line="hideDetails" :label="label" :hide-details="hideDetails" v-model="selectedValue" :items="itemsDoorLock" append-icon=""></v-select>
  <v-select v-else-if="isThermostatFan" box dense :single-line="hideDetails" :label="label" :hide-details="hideDetails" v-model="selectedValue" :items="itemsThermostatFan" append-icon=""></v-select>
  <v-select v-else-if="isThermostatMode" box dense :single-line="hideDetails" :label="label" :hide-details="hideDetails" v-model="selectedValue" :items="itemsThermostatMode" append-icon=""></v-select>
  <v-select v-else-if="isSiren" box dense :single-line="hideDetails" :label="label" :hide-details="hideDetails" v-model="selectedValue" :items="itemsSiren" append-icon=""></v-select>
  <!-- <v-select v-else-if="isThermostatTemperature" box dense :single-line="hideDetails" :label="label" :hide-details="hideDetails" v-model="selectedValue" :items="itemsThermostatTemperature"></v-select> -->
  <v-text-field v-else box dense :single-line="hideDetails" :label="label" :hide-details="hideDetails" mask="###" v-model="selectedValue" :rules="rulesValue"></v-text-field>
</v-layout>
</template>

<script>
export default {
  name: 'DeviceStateSelector',
  props: {
    value: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      require: true
    },
    'hideDetails': {
      type: Boolean,
      default: true
    },
    label: {
      type: String
    }
  },
  data() {
    return {
      rulesValue: [v => (parseInt(v) >= 0 && parseInt(v) <= 255) || 'error'],
      itemsSwitch: [{
        value: 255,
        text: this.$t('device.turn_on')
      }, {
        value: 0,
        text: this.$t('device.turn_off')
      }],
      itemsLevel: [100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 0].map(v => ({
        value: Math.min(99, v),
        text: `${v}%`
      })),
      itemsDoorLock: [{
        value: 255,
        text: this.$t('device.lock')
      }, {
        value: 0,
        text: this.$t('device.unlock')
      }],
      itemsThermostatFan: ['fan_off', 'fan_auto_low', 'fan_low', 'fan_auto_high', 'fan_high'].map((v, i) => ({
        text: this.$t(`device.${v}`),
        value: i
      })),
      itemsThermostatMode: ['mode_off', 'mode_heat', 'mode_cool', 'mode_auto'].map((v, i) => ({
        text: this.$t(`device.${v}`),
        value: i
      })),
      itemsSiren: ['siren_off', 'siren_fire', 'siren_ambulance', 'siren_police', 'siren_alarm', 'siren_ding_dong', 'siren_beep'].map((v, i) => ({
        text: this.$t(`device.${v}`),
        value: i
      }))
    }
  },
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(val) {
        return this.$emit('input', val);
      }
    },
    isSwitch() {
      return [23, 28].includes(this.item.ctrltype);
    },
    isLevel() {
      return [24, 26, 30, 41].includes(this.item.ctrltype);
    },
    isDoorLock() {
      return [31].includes(this.item.ctrltype);
    },
    isThermostatFan() {
      return [32].includes(this.item.ctrltype);
    },
    isThermostatMode() {
      return [33].includes(this.item.ctrltype);
    },
    isThermostatTemperature() {
      return [34].includes(this.item.ctrltype);
    },
    isSiren() {
      return [25].includes(this.item.ctrltype);
    }
  },
  mounted() {
    // console.log(this.item);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/device/DeviceStateSelector.vue